import { call, put, takeEvery, select, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import {
  searchMyGigsLocationSuggestionsApi,
  searchMyGigsSkillsApi,
} from "../../API/API";
import {
  keySearchMyGigsDynamicLocationFailure,
  fetchMyGigsKeySearchSkillsFailure,
} from "../actions";


function* searchMyGigsLocationSuggestionsSaga(params) {
  try {
    let response = yield call(searchMyGigsLocationSuggestionsApi, params); // API Backend
    if (params?.payload?.value) {
      response.data.value = params?.payload?.value;
    }
    if (response?.data) {
      yield put({
        type: types.SEARCH_MY_GIGS_DYNAMIC_LOCATION_SUCCESS,
        payload: response.data,
      });
    } else {
      yield put(keySearchMyGigsDynamicLocationFailure());
    }
  } catch (error) {
    yield put(keySearchMyGigsDynamicLocationFailure(error));
  }
}

function* searchMyGigsSkillsSaga(params) {
  try {
    let response = yield call(searchMyGigsSkillsApi, params); // API Backend
    if(response?.data){
      yield put({
        type: types.FETCH_MY_GIGS_SEARCH_SKILLS_SUCCESS,
        payload: response?.data,
      });
    }else{
      yield put(fetchMyGigsKeySearchSkillsFailure());
    }
  } catch (error) {
    yield put(fetchMyGigsKeySearchSkillsFailure(error));
  }
}

export function* watchSearchMyGigsLocationSuggestionsSaga() {
  yield takeLatest(
    types.SEARCH_MY_GIGS_LOCATION_INIT,
    searchMyGigsLocationSuggestionsSaga
  );
}

export function* watchSearchMyGigsSkillsSaga() {
  yield takeLatest(types.FETCH_MY_GIGS_SEARCH_SKILLS_INIT, searchMyGigsSkillsSaga);
}
